module.exports = __webpack_public_path__ + "static/media/selectIcon1.94796e1a.png";